import React from 'react';
import { Noimage } from '../../common/imagePath';

const Image = {
  className: String,
  src: String,
  alt: String,
  height: Number,
  width: Number,
  id: String,
  mode: String, // circle or square
};

const ImageWithBasePath = (props = Image) => {
  const { className, src, alt, height, width, id, mode, onClick=()=>{}, title="" } = props;

  // Conditional styles for circle or square
  const imageStyles = {
    borderRadius: mode === 'circle' ? '50%' : '0%', // 50% for circle, 0% for square
    height: `${height}px`,
    width: `${width}px`,
  };

  return (
    <img
      className={className}
      src={src}
      height={height}
      alt={alt}
      width={width}
      id={id}
      style={imageStyles}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = Noimage;
      }}
      onClick={onClick}
      title={title}
    />
  );
};

export default ImageWithBasePath;
